var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2",attrs:{"icon":"","small":"","color":"blue lighten-2"},nativeOn:{"click":function($event){return _vm.pressed.apply(null, arguments)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }